export const SCREEN_CHART_MARGIN_RIGHT = 48;
export const PRINT_CHART_MARGIN_RIGHT = 56;

/** 印刷専用DOM全体の縮小率 */
export const PRINT_CONTENT_SCALE = 0.8;

export const getPrintPx = (size: number, isPrinting: boolean): number =>
  isPrinting ? Math.round(size * PRINT_CONTENT_SCALE) : size;

export const getChartMarginRight = (isPrinting: boolean) =>
  isPrinting ? PRINT_CHART_MARGIN_RIGHT : SCREEN_CHART_MARGIN_RIGHT;
